import {useQuery} from '@tanstack/react-query'
import api from 'src/services/api'
import {AlarmCenterZone} from 'src/services/api/endpoints/AlarmCenterEndpoint'
import {Paginate} from 'src/services/api/endpoints/_types'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  alarmCenterId: number
  enabled?: boolean
}

const emptyResult: Paginate<AlarmCenterZone> = {
  totalElements: 0,
  entities: [],
  currentPage: 1,
}

export default function useAlarmCenterZones({alarmCenterId, enabled = true}: Props) {
  return useQuery({
    enabled: enabled && alarmCenterId > 0,
    refetchOnWindowFocus: false,
    retry: false,
    queryKey: [QueryKeyEnum.ALARM_CENTER_ZONES, 'by-center', alarmCenterId],
    queryFn: async () => {
      try {
        return (
          await api.alarmCenter.getZones({
            page: 1,
            pageSize: 100,
            filter: {alarmCenterId},
          })
        ).data.data
      } catch {
        return emptyResult
      }
    },
  })
}
